const BackIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => {
  return (
    <svg viewBox="0 0 15 15" fill="none" {...props}>
      <path
        d="M15 12.9421C13.2874 10.834 11.7667 9.63788 10.4374 9.35341C9.10845 9.06929 7.8432 9.02624 6.6413 9.22459V13L1 6.83941L6.6413 1V4.58835C8.86345 4.606 10.7524 5.41 12.3085 7C13.8643 8.59 14.7617 10.5707 15 12.9421Z"
        fill="#E7DEFF"
        stroke="#8065C9"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackIcon;
